module.exports = __webpack_public_path__ + "static/media/AC_value.9525db93.png";